// extracted by mini-css-extract-plugin
export default {"container":"index_container_ObpKT","btn":"index_btn_itmwP","btnMore":"index_btnMore_BQr5I","mask":"index_mask_4APlu"};